const GOOGLE_API_KEY = "AIzaSyDZJM93o8cwabh3h2K4FerQHRZ9f0-h58Y";
const PH_HOST = "customer.zap.com.ph";
const USA_HOST = "www.zaployalty.com";
const SG_HOST = "sg.zaployalty.com";
const MY_HOST = "my.zaployalty.com";
const VN_HOST = "vn.zaployalty.com";
const ZAP_DEALS_LINK = "https://zapdeals.com.ph";
const E_STORE_LINK = "https://zapestore.com";
const INTERCOM_APP_ID = "nr8niow0";
const GOOGLE_ANALYTICS_TRACKING_ID = "UA-37253735-1";
const GOOGLE_CONVERSION_ID = "1037596324";
const GOOGLE_CONVERSION_LABEL = "GAYPCJXeuWsQpO3h7gM";
const LOYALTY_EXPRESS_SIGNUP = "https://merchants.zaployalty.com/signup";
const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=ph.com.zap.android";
const APP_STORE_LINK =
  "https://itunes.apple.com/ph/app/zap-philippines/id907381118";
const PH_BUSINESS_HOST = "https://www.zap.com.ph";
export {
  PLAY_STORE_LINK,
  APP_STORE_LINK,
  GOOGLE_API_KEY,
  PH_HOST,
  USA_HOST,
  SG_HOST,
  MY_HOST,
  VN_HOST,
  INTERCOM_APP_ID,
  GOOGLE_ANALYTICS_TRACKING_ID,
  GOOGLE_CONVERSION_ID,
  GOOGLE_CONVERSION_LABEL,
  ZAP_DEALS_LINK,
  E_STORE_LINK,
  LOYALTY_EXPRESS_SIGNUP,
  PH_BUSINESS_HOST,
};



// WEBPACK FOOTER //
// ./config/config.prod.js